/* src/app/forms/formula-tester/formula-tester-action/formula-tester-action.component.scss */
.formula-panel {
  display: flex;
  height: 100%;
  flex-direction: row;
}
.formula-left-panel {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  margin-right: 10px;
  overflow: auto;
}
.list-icon {
  display: flex;
  flex-direction: row;
  padding-right: 10px;
}
.search-panel {
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: auto;
  width: 100%;
}
.formula-right-panel {
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-left: 10px;
  min-width: 300px;
}
.item-line {
  max-width: 300px;
  font-size: 120%;
  cursor: pointer;
  text-overflow: ellipsis;
  display: block;
  white-space: nowrap;
  overflow: hidden;
}
mat-list-item:hover {
  background-color: color-mix(in srgb, var(--tem-ink) 12%, transparent);
}
.filterclass2 {
  padding: 6px;
}
mat-form-field {
  width: 100%;
}
.list-formula {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: auto;
  padding: 5px;
  margin: 5px;
}
.box-description {
  display: flex;
  height: 100%;
  width: 100%;
  max-height: 150px;
  flex-direction: column;
  padding-bottom: 4px;
}
.box-description-result {
  display: flex;
  height: 50%;
  flex-direction: column;
  padding-bottom: 4px;
}
.mat-mdc-subheader {
  text-decoration: underline;
}
.box-description-detail {
  display: flex;
  flex-direction: column;
  padding-top: 6px;
  padding-bottom: 6px;
  overflow: auto;
  height: 100%;
  border-style: inset;
  scroll-behavior: smooth;
  border-width: thin;
  border-radius: 4px;
}
.box-description-detail-title {
  font-weight: bold;
  font-size: 100%;
  overflow-wrap: break-word;
  word-break: break-word;
  margin-top: 5px;
  padding-left: 5px;
}
.box-description-detail-info {
  font-size: 90%;
  overflow-wrap: break-word;
  word-break: break-word;
  margin-left: 15px;
  margin-right: 15px;
}
.sintaxe {
  cursor: pointer;
}
.sintaxe:hover {
  background-color: color-mix(in srgb, var(--tem-ink) 12%, transparent);
}
.item-line-main {
  height: 100%;
}
.formula-context {
  display: flex;
  height: 100%;
  width: 100%;
  flex-direction: column;
  gap: 8px;
}
.customtextarea {
  height: 100%;
  resize: none;
  display: flex;
  flex-direction: column;
  overflow: auto;
  padding-top: 6px;
}
.customtextarea .mat-mdc-form-field-flex {
  padding-bottom: 0 !important;
  height: 100%;
}
.boxtext {
  display: flex;
  flex-direction: column;
  height: 50%;
}
.formula-result {
  display: flex;
  height: 20%;
  overflow: auto;
}
.result-formula {
  height: 100%;
  padding: 10px;
  word-break: break-all;
}
textarea {
  resize: none;
}
.formula-panel-small {
  display: flex;
  width: 100%;
  flex-direction: column;
  height: 100%;
}
.box-description-small {
  max-height: 100% !important;
  padding-left: 4px;
  width: 100%;
}
.formula-left-panel-small {
  display: flex;
  flex-direction: row;
  width: 100%;
  padding-bottom: 4px;
  width: 100%;
}
.formula-right-panel-small {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: row;
  margin-left: 0px !important;
}
.list-formula-item {
  display: flex;
  flex-direction: row;
  width: 100%;
  position: relative;
  align-items: center;
}
mat-list-item {
  display: flex;
  flex-direction: row;
  position: relative !important;
}
/*# sourceMappingURL=formula-tester-action.component.css.map */
